module.exports = __webpack_public_path__ + "static/media/ST4.5aac7762.mp3";